/* beautiful-react-hooks version: 0.25.5 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _rollupPluginBabelHelpers = require('./_virtual/_rollupPluginBabelHelpers.js');

var react = require('react');

var createHandlerSetter = require('./utils/createHandlerSetter.js');

var createCbSetterErrorProxy = require('./utils/createCbSetterErrorProxy.js');

var isClient = require('./utils/isClient.js');

var isAPISupported = require('./utils/isAPISupported.js');

var defaultOptions = {
  increment: 1,
  startAt: 0,
  finishAt: 100
};
var errorMessage = 'requestAnimationFrame is not supported, this could happen both because ' + 'window.requestAnimationFrame is not supported by your current browser version or you\'re using the ' + 'useRequestAnimationFrame hook whilst server side rendering.';

var useRequestAnimationFrame = function useRequestAnimationFrame(func) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;

  if (!isClient.default || !isAPISupported.default('requestAnimationFrame')) {
    console.warn(errorMessage);
    return createCbSetterErrorProxy.default(errorMessage);
  }

  var opts = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, defaultOptions), options);

  var progress = react.useRef(opts.startAt);

  var _createHandlerSetter = createHandlerSetter.default(),
      _createHandlerSetter2 = _rollupPluginBabelHelpers.slicedToArray(_createHandlerSetter, 2),
      onFinish = _createHandlerSetter2[0],
      setOnFinish = _createHandlerSetter2[1];

  var next = function next() {
    return window.requestAnimationFrame(step);
  };

  var step = react.useCallback(function () {
    if (progress.current <= opts.finishAt || opts.finishAt === -1) {
      func(progress.current, next);
      progress.current += opts.increment;
    } else if (onFinish.current) {
      onFinish.current();
    }
  }, [func, opts.finishAt, opts.increment, progress.current, onFinish.current]);

  if (progress.current <= opts.startAt) {
    next();
  }

  return setOnFinish;
};

exports.default = useRequestAnimationFrame;